export const longOperationsConfig = {
    refreshInterval: 10 * 1000
};
